import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

export const fetchKzt2Config = async () => {
  const response = await apiService.makeRequest('/api/kzt2/')
  if (!response.kzt) throw new Error('Invalid response format: kzt config not found')
  return { ...response.kzt, promo: response.promo || null }
}

export const fetchKzt2Packages = async () => {
  const response = await apiService.makeRequest('/api/topup/')
  if (!Array.isArray(response.topup)) throw new Error('Invalid response format: topup array not found')
  return response.topup.filter((pkg) => Number.isSafeInteger(pkg.kzt2) && pkg.kzt2 > 0)
}

const createKzt2Payment = async (body) => {
  const amount = Object.values(body)[0]
  if (!Number.isSafeInteger(amount) || amount <= 0) throw new Error('INVALID_AMOUNT')
  try {
    const response = await apiService.makeRequest('/api/kzt2/', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    if (response?.error) throw new Error(response.error)
    if (!response?.link) throw new Error('Invalid response format: link not found')
    return { link: response.link }
  } catch (error) {
    if (error.message === 'error sum') throw new Error('INVALID_AMOUNT')
    if (error.message === 'error limit') throw new Error('LIMIT_ORDER')
    if (error.message === 'error backend') throw new Error(error.status === 400 ? 'INVALID_REQUEST' : 'BACKEND_ERROR')
    throw error
  }
}

export const createPaymentByKzt = (kzt) => createKzt2Payment({ kzt })
export const createPaymentByCrystals = (crystals) => createKzt2Payment({ crystal: crystals })
export const openKzt2Payment = (link, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(link, onRedirect, 'KZT', paymentWindow)
}

export default {
  fetchKzt2Config,
  fetchKzt2Packages,
  createPaymentByKzt,
  createPaymentByCrystals,
  openKzt2Payment
}
